<div class="content">
  <div class="content__head">
    <h1>{{ title }}</h1>
    <ng-content select="[actions]"></ng-content>
    <div
      *ngIf="!!creatableActions?.length"
      class="action-buttons"
      style="border-bottom: solid 1px #ccc; padding-bottom: 1rem">
      <ng-container *ngFor="let action of creatableActions">
        <button
          mat-stroked-button
          color="{{ action.color || 'primary' }}"
          [title]="action.description || action.title"
          (click)="action.action()"
          *ngIf="action.isVisible !== false">
          <mat-icon>{{ action.iconName || 'add' }}</mat-icon>
          <span>{{ action.title }}</span>
        </button>
      </ng-container>
    </div>
    <div class="grid-features">
      <custom-filter-menu
        [currentConfig]="currentConfig"
        [pageId]="entityPrefix"
        (onConfigApply)="
          restoreState({ columnState: $event.columnState, filterModel: $event.filterModel })
        " />
      <div class="action-buttons">
        <button mat-stroked-button color="primary" title="Aktualisieren" (click)="refresh()">
          Aktualisieren
          <mat-icon>cached</mat-icon>
        </button>
        <button mat-stroked-button color="primary" title="Filter zurücksetzen" (click)="resetFilters()">
          Filter zurücksetzen
          <mat-icon>search_off</mat-icon>
        </button>
        <button
          mat-stroked-button
          color="primary"
          title="Anordnung der Spalten zurücksetzen"
          (click)="resetColumnArrangement()">
          Spalten zurücksetzen
          <mat-icon>compare_arrows</mat-icon>
        </button>
        <button mat-stroked-button color="primary" title="Excel Export" (click)="exportToExcel()">
          Excel Export
          <mat-icon>cloud_download</mat-icon>
        </button>
      </div>
      <div class="grid-info">
        <button
          mat-stroked-button
          color="primary"
          title="Anleitung zu Listenfunktionen"
          (click)="openInfoModal()">
          Neue Funktionen
          <mat-icon>info_outline</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div class="content__body">
    <ag-grid-angular
      [localeText]="localeText"
      style="width: 100%; height: 100%"
      class="ag-theme-material"
      [getContextMenuItems]="getContextMenuItems"
      [columnDefs]="columnDefs$ | async"
      [defaultColDef]="defaultColumnDefs$ | async"
      [animateRows]="true"
      [pagination]="true"
      [rowModelType]="'serverSide'"
      [rowSelection]="rowSelection"
      [paginationPageSize]="userPageSize$ | async"
      [cacheBlockSize]="userPageSize$ | async"
      (gridReady)="onGridReady($event)"
      (cellClicked)="onCellClicked($event)"></ag-grid-angular>
  </div>

  <div *ngIf="showExportAgGrid">
    <ag-grid-angular
      [localeText]="localeText"
      style="width: 0%; height: 0%"
      class="ag-theme-material"
      [columnDefs]="columnDefs$ | async | entityListPageExport"
      [defaultColDef]="defaultColumnDefs$ | async | entityListPageExport"
      [animateRows]="true"
      [pagination]="true"
      (paginationChanged)="onExportGridPaginationChanged($event)"
      [rowModelType]="'serverSide'"
      [paginationPageSize]="10000"
      [cacheBlockSize]="10000"
      (gridReady)="onExportGridReady($event)"></ag-grid-angular>
  </div>

  <app-loading-overlay *ngIf="isExporting"></app-loading-overlay>
</div>
